<template>
  <div class="product-how-to-use" v-if="customFields.how_to_use_headline || customFields.how_to_use_description || customFields.how_to_use_placeholder_image || customFields.how_to_use_vimeo_link">
    <header class="product-how-to-use__header" v-if="customFields.how_to_use_headline || customFields.how_to_use_description">
      <h3 class="h2" v-if="customFields.how_to_use_headline">{{customFields.how_to_use_headline}}</h3>
      <div class="body-md" v-if="customFields.how_to_use_description">{{customFields.how_to_use_description}}</div>
    </header>
    <div class="product-how-to-use__video-wrapper" :style="videoType" v-if="customFields.how_to_use_placeholder_image || customFields.how_to_use_vimeo_link">
      <transition name="fade">
        <div class="product-how-to-use__video-placeholder" v-on:click="onPlay" v-if="!hidePlaceholder">
          <img :src="customFields.how_to_use_placeholder_image" alt="">
          <icon name="play_button" :size="iconSize" />
        </div>
      </transition>
      <div class="product-how-to-use__video-vimeo">
        <iframe ref="vimeoPlayer" class="product-how-to-use__video-vimeo-iframe" :src="customFields.how_to_use_vimeo_link" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import Player from '@vimeo/player';
import Icon from '../basic/Icon.vue';
export default {
  name: "ProductHowToUse",
  props: {
    customFields: Object,
  },
  data () {
    return {
      hidePlaceholder: false
    }
  },
  components: {
    Icon
  },
  methods: {
    onPlay() {
      let thePlayer = new Player(this.$refs.vimeoPlayer);
      this.hidePlaceholder = true;
      thePlayer.play();
    }
  },
  created () {
    this.hidePlaceholder = !this.customFields.how_to_use_placeholder_image;
  },
  computed: {
    videoUrl() {
      if(this.customFields.how_to_use_vimeo_link.includes('vimeo.com')) {
        return this.customFields.how_to_use_vimeo_link;
      }else {
        return this.customFields.how_to_use_vimeo_link;
      }

    },
    videoType(){
      if(this.customFields.video_orientation=="Vertical") {
        return {
          width: "100%",
          overflow: "hidden",
          height: "75vh"
        }
      }
    },
    iconSize() {
      return this.$mq === 'mobile' ? '68' : '86';
    }
  }
}
</script>

<style lang="scss" scoped>
.product-how-to-use {
  max-width: 1000px;
  margin: 0 auto;
  padding: 80px 16px 88px;
  text-align: center;

  &__header {
    margin-bottom: 24px;
    @include tablet-up {
      margin-bottom: 34px;
    }

    .h2 {
      line-height: rem(34);
      @include tablet-up {
        line-height: rem(48);
      }
    }

    .body-md {
      color: $color-black-700;
      line-height: rem(23);
    }
  }
  &__video-wrapper {
    height: 0;
    padding-top: 56.25%;
    position: relative;
    @include mobile-only{
      width: 100%;
      overflow: hidden;
      height: 75vh;
    }
  }

  &__video-placeholder,
  &__video-vimeo {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  &__video-vimeo-iframe{
    @include mobile-only{
      position: absolute;
      top:0;
      left:0;
      width:100%;
      height: 100%;
    }
  }
  &__video-placeholder {
    cursor: pointer;
    z-index: 2;

    img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      object-fit: cover;
      object-position: center center;
      pointer-events: none;
    }
    .icon {
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      left: 50%;
    }
  }
  &__video-vimeo {
    z-index: 1;
  }
}
</style>
